import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import ArrowIosDown from '@crehana/compass.icons.outline/ArrowIosDown';
import ArrowIosUp from '@crehana/compass.icons.outline/ArrowIosUp';
import { Collapse } from '@crehana/compass.ui';
import { useTranslation } from '@crehana/i18n';
import { clsx } from 'clsx';
import locales, { COLLAPSE_PERMISSIONS_ROLE } from "../i18n";
import ContentCollapseResume from "./ContentCollapseResume";
import HeaderCollapse from "./HeaderCollapse";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var CollapsePermissionsResume = function CollapsePermissionsResume(_ref) {
  var moduleKey = _ref.moduleKey,
    name = _ref.name,
    permissions = _ref.permissions;
  var _useTranslation = useTranslation(COLLAPSE_PERMISSIONS_ROLE),
    addResourceBundle = _useTranslation.addResourceBundle;
  addResourceBundle(locales);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var Icon = open ? ArrowIosDown : ArrowIosUp;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-pb-1.6",
    children: [/*#__PURE__*/_jsxs("div", {
      className: clsx(open ? 'tw-border-primary-light-500' : 'tw-border-neutral-light-400', 'tw-h-6.4 tw-cursor-pointer tw-px-2.4 tw-py-1.2 tw-flex tw-items-center tw-flex-row tw-rounded-1.2 tw-border tw-border-solid'),
      onClick: function onClick() {
        return setOpen(!open);
      },
      onKeyDown: function onKeyDown(e) {
        // biome-ignore lint/style/useBlockStatements: single-line early return
        if (e.key === 'Enter' || e.key === ' ') setOpen(!open);
      },
      children: [/*#__PURE__*/_jsx(Icon, {
        className: "tw-mr-2.4 tw-text-primary-light-500",
        size: 24
      }), /*#__PURE__*/_jsx(HeaderCollapse, {
        name: name,
        permissions: permissions
      })]
    }), /*#__PURE__*/_jsx(Collapse, {
      open: open,
      className: clsx(open && '!tw-h-auto tw-mt-0.8', 'tw-w-full'),
      children: /*#__PURE__*/_jsx(ContentCollapseResume, {
        moduleKey: moduleKey,
        permissions: permissions
      })
    })]
  });
};